import { useEffect } from 'react';

// Injects per-route JSON-LD into <head> (and removes it on unmount) so each
// product page carries its own MedicalDevice + FAQ + Breadcrumb structured data
// instead of relying only on the static site-wide schema in index.html.
const StructuredData = ({ id, schema }) => {
  useEffect(() => {
    if (!schema) return undefined;
    const elId = `ld-${id}`;
    let el = document.getElementById(elId);
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = elId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);
    return () => {
      const existing = document.getElementById(elId);
      if (existing) existing.remove();
    };
  }, [id, schema]);
  return null;
};

export default StructuredData;
